module.exports = __webpack_public_path__ + "improve.2Fi5VR2Y.svg";